import { render } from "./Dashboard.vue?vue&type=template&id=20670748&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "../assets/css/dashboard.css?vue&type=style&index=0&id=20670748&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20670748"]])

export default __exports__